import React, { useState } from 'react';
import PropTypes from 'prop-types';
// common components
import AuthBackground from './../AuthBackground/AuthBackground';
import FormField from './../../../common/Forms/FormField/FormField';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import { email } from './../../../common/Forms/Validation/FieldLevelValidation';
import FontIcon from './../../../common/FontIcon/FontIcon';
// css
import './Login.scss';


const Login = ({ loginContext, history }) => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [forgetPassword, setForgetPassword] = useState(true);

	const [successMessage, setSucessMessage] = useState(false);
	
	function setforgetpassword(){ 
		loginContext.loginError='';
	    setForgetPassword(!forgetPassword);
		setSucessMessage(false);
	}

	return (
		<AuthBackground>
			{
				loginContext.loginError !== '' && 
				<div className='login-error'>{loginContext.loginError}</div>
			}
			<div className='desc-mock'>Mock Exam</div>

		    {/* Creation of Forgot password Form	 */}

			{forgetPassword ?
			<form onSubmit={(e) => {
				e.preventDefault();
				loginContext.onLoginSubmit({username, password}, history)
			}}>
			<div>
				 <p className="login-page"> Login </p> 
				  <FormField
					autoFocus
					label="Email"
					name="username"
					placeholder="Enter Username"
					value={ username }
					onChange={ e => setUsername(e.target.value) }
					validate={['required', 'email']}
				/>	
				<FormField
				label="Password"
				name="password"
				type="password"
				placeholder="Enter Password"
				value={ password }
				onChange={ e => setPassword(e.target.value) }
				validate={['required']}
				maxLength={50}
				
			/>	
			 <div className="main">
				  <p className="forgot-password" onClick={()=>setforgetpassword()}>Forgot Password?</p>	
				  <div className="custombutton">
				    <CustomButton 
					name="submit"
					type="submit"
					disabled={ username === '' || password === '' || typeof email(username) === 'string' }
				   />
				  </div>
				</div>
			</div></form>	
				:	  
			    <form onSubmit={(e) => {
					e.preventDefault();
					const email ={
						email: username
					}
					setUsername("");
					setPassword("");
					setSucessMessage(true);					
					console.log('sent forget request email',username);
					loginContext.onForgetSubmit(email);
					}}>
			  <div>

				 <p className="forgot-password-page">Forgot Password</p> 
				 {successMessage&&
				 <div className="forgot-message">
					<div className="forget-success-message">
						<div className='forget-success-icon'><FontIcon iconName='tick_circle' /></div>
						<div className="forgot-msg">An email message has been sent containing new password.</div>
					</div>
				      <span className="login-text">Click 
					  <span className="login-link" onClick={()=>setforgetpassword()}> here </span> 
					  to return to Login</span>
				</div>}
				 
					<FormField
					autoFocus
					label="Email"
					name="username"
					placeholder="Enter Username"
					value={ username }
					onChange={ e => setUsername(e.target.value) }
					validate={['required', 'email']}
				/>
				<div className="mainclass">					
				<CustomButton 
					name="Send"
					type="submit"
					disabled={ username === '' || typeof email(username) === 'string' }
				   />
				</div>
                </div>	
				</form>	
			 }			    				
		</AuthBackground>
	);
	
}

Login.propTypes = {
    value: PropTypes.instanceOf(Object),
    history: PropTypes.instanceOf(Object)
};

Login.defaultProps = {
    value: {},
    history: {}
};

export default Login;



// WEBPACK FOOTER //
// ./components/Auth/Login/Login.js